export default __webpack_public_path__ + "static/media/low_amount.0989a0c7.svg";